export default __webpack_public_path__ + "static/media/logo_official.e1a65443.png";